import styles from "./index.module.scss";
import { Spacer } from "../Atoms/Vectors";
import { ReactNode } from "react-markdown/lib/react-markdown";

const ObliqueSpacer = ({
  type,
  color,
  textColor,
  children,
  route,
}: {
  type: string;
  color: any;
  textColor: any;
  children: ReactNode;
  route?: string;
}) => {
  return (
    <div
      className={` ${
        route != "/age-gate"
          ? `${styles.spacerRelative}`
          : `${styles.spacerFixed}`
      }  `}
      style={{ background: color.hex, color: textColor.hex }}
    >
      <Spacer type={type} color={color} />
      {children}
    </div>
  );
};

export default ObliqueSpacer;
